import { css } from 'lit';

export const styles = css`
  

  .assets-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
    overflow: hidden; /* only the table-container scrolls */
  }

  /* Header */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--sl-color-neutral-0);
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 1rem;
    position: sticky;
    top: 0;
    z-index: 5;
  }
  .title-group{
    display: flex;
    gap: 0.75rem;
  }
  .filters {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  /* Table */
  .table-container {
    flex: 1;
    min-height: 0;
    overflow: auto;
    
  }

  table.assets-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed; /* stable layout */
    background: var(--sl-color-neutral-0);
  }

  thead th {
    position: sticky;
    top: 0; /* stick to top of scroll area */
    z-index: 2;
    background: var(--sl-color-neutral-0); /* opaque so rows can't bleed through */
    border-bottom: 1px solid var(--sl-color-neutral-200);
    text-align: left;
    font-weight: 600;
    padding: 0.75rem;
    white-space: nowrap;
    user-select: none;
    box-shadow: 0 1px 0 0 var(--sl-color-neutral-200); /* divider */
  }

  th[role="button"] {
    cursor: pointer;
  }

  .column-header {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  tbody tr {
    height: 48px; /* consistent row height */
    cursor: pointer;
  }

  tbody td {
    border-bottom: 1px solid var(--sl-color-neutral-200);
    padding: 0.75rem;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  tr:hover {
    background: var(--sl-color-neutral-50);
  }

  tr[tabindex="0"] {
    outline: none;
  }

  .name-cell .name {
    display: flex;
    gap: 0.5rem;
    align-items: baseline;
  }

  .name .primary {
    font-weight: 600;
  }

  .name .secondary {
    color: var(--sl-color-neutral-500);
    font-size: 0.85rem;
  }

  .actions-col,
  .row-actions {
    text-align: right;
    white-space: nowrap;
  }

  /* ✅ Created column fix */
  .created-col {
    width: auto;          /* let it grow naturally */
    min-width: 140px;     /* enough room for dd/MM/yyyy */
    white-space: nowrap;  /* keep date on one line */
  }

  tbody td.created-cell {
    overflow: visible;    /* don’t clip the text */
    text-overflow: clip;  /* no ellipsis */
    white-space: nowrap;
  }

  /* Empty & skeleton */
  .empty-state .empty {
    text-align: center;
    padding: 2rem;
    color: var(--sl-color-neutral-500);
  }

  .empty sl-icon {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  tr.skeleton td {
    padding: 0.5rem 0.75rem;
  }

  .skeleton-bar {
    height: 14px;
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      var(--sl-color-neutral-200) 25%,
      var(--sl-color-neutral-150) 37%,
      var(--sl-color-neutral-200) 63%
    );
    background-size: 200% 100%;
    animation: skeleton-loading 1.4s ease infinite;
  }

  @keyframes skeleton-loading {
    0% { background-position: 0 0; }
    100% { background-position: 200% 0; }
  }

  /* Delete dialog */
  .modal-body {
    padding: 1rem 0 0.25rem 0;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  /* Mobile */
  @media (max-width: 768px) {
    .filters { gap: 0.5rem; }
  }
`;
